export interface PreferenceSectionProps {
  setAlertCode: React.Dispatch<React.SetStateAction<string | null>>;
}

export enum UserState {
  PUBLIC = 'public',
  PRIVATE = 'private',
}
